import React from 'react';
import { FormattedMessage } from 'react-intl';

import { messages } from './../messages';
import UserDateTimezoneFormat from '../../../../../components/user-date-timezone-format';
import { purchaseOrderGridProperties } from '../../data/purchase-order-properties';

const name = <FormattedMessage {...messages.createDateColumnHeader} />;

/**
 * Create Date column configuration
 * Displays the date when the purchase order was created
 * Uses UserDateTimezoneFormat to format the date according to user's timezone
 * @type {import('./types').GridColumn} Column configuration object
 */
export const createDateColumn = {
  name,
  render: (data) => {
    const { createDate } = data;
    return createDate && <UserDateTimezoneFormat dateTime={createDate} />;
  },
  id: purchaseOrderGridProperties.createDate,
};
